import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

interface IConsultaRelatorioSAP {
  empresa: string;
  contratos?: Array<string>;
  ano?: string;
  mes?: string;
}

interface EnviarAvisoDTO {
  lojas: Array<{NumContrato: string}>;
  title: string;
  texto: string;
  sendEmail: boolean;
}

@Injectable()
export class InformeVendasProvider {
  private header = APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {}

  
  async enviarAviso(
    empresa: string,
    data: EnviarAvisoDTO
  ): Promise<{ Item: any; erro: string }> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'boletoscobranca';

      me.http
        .post(url, data, {
          headers: me.header,
          params: {
            empresa: empresa,
            operacao: 'enviarAviso',
            tipoAviso: 'Aviso de Vendas não Informadas'
          },
        })
        .subscribe(
          (result: any) => {
            ////console.log(result);
            //resolve(result.json());
            var jsonData = result;

            if (jsonData) {
              if (jsonData.status_ret != 'NOK') {
                var datasuccess = {
                  Item: jsonData,
                  erro: '',
                };

                me.itemret = datasuccess;
              } else {
                var errodatavazio = {
                  Item: null,
                  erro: 'Erro na consulta dos boletos e avisos.',
                };
                me.itemret = errodatavazio;
              }

              //resolve(me.itemret);
            } else {
              var errodatavazio1 = {
                Item: null,
                erro: 'Nenhum registro encontrado.',
              };
              me.itemret = errodatavazio1;
            }
            resolve(me.itemret);
          },
          (error) => {
            var msg = '';
            if (error.status == 401) {
              msg = error.statusText;
            } else {
              msg = error.error;
            }
            let errojson = msg;

            var errochamada = {
              Item: null,
              erro: errojson,
            };
            me.itemret = errochamada;
            reject(me.itemret);
          }
        );
    });
  }

  async getAviso(): Promise<{ Item: any; erro: string }> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'boletoscobranca?operacao=enviarAviso';

      me.http
        .get(url, {
          headers: me.header,
        })
        .subscribe(
          (result: any) => {
            var jsonData = result;

            if (jsonData) {
              if (jsonData.status_ret != 'NOK') {
                var datasuccess = {
                  Item: jsonData,
                  erro: '',
                };

                me.itemret = datasuccess;
              } else {
                var errodatavazio = {
                  Item: null,
                  erro: 'Erro na consulta dos boletos e avisos.',
                };
                me.itemret = errodatavazio;
              }

              //resolve(me.itemret);
            } else {
              var errodatavazio1 = {
                Item: null,
                erro: 'Nenhum registro encontrado.',
              };
              me.itemret = errodatavazio1;
            }
            resolve(me.itemret);
          },
          (error) => {
            var msg = '';
            if (error.status == 401) {
              msg = error.statusText;
            } else {
              msg = error.error;
            }
            let errojson = msg;

            var errochamada = {
              Item: null,
              erro: errojson,
            };
            me.itemret = errochamada;
            reject(me.itemret);
          }
        );
    });
  }
  
  /**
   * Lista informes pendentes
   */
  consultarPeriodo(): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url =
        APIService.API_URL +
        `informevendas?operacao=consultarPeriodos`;

      me.http.get(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  consultarMotivosNaoFaturamento(): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url =
        APIService.API_URL +
        `informevendas?operacao=idMotivoNaoFaturamento`;

      me.http.get(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  /**
   * Lista informes pendentes
   */
  getInformeVendasByIdProcesso(idInstancia, idEmpresa): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas?operacao=analise_bpm&idInstancia=${idInstancia}&empresa=${idEmpresa}`;

      me.http.get(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  /**
   * Lista informes pendentes
   */
  getInformeVendas(empresa, contrato, datade, dataate) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas?empresa=${empresa}&contrato=${contrato}
    &dataDe=${datade}&dataAte=${dataate}`;

      me.http.get(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }
  getInformeVendasPeriodo(empresa, contrato) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas?operacao=informesPeriodo&empresa=${empresa}&contrato=${contrato}`;

      me.http.get(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  /**
   * Lista atividades para aprovação
   */
  getAtividadesAprovacao(idProcesso: string) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url =
        APIService.API_URL + `informevendas`;

      me.http.get(url, { headers: me.header, params: {
        operacao: 'analise_bpm',
        idInstancia: idProcesso
      } }).subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  consultarRelatoriosSAP({
    empresa,
    contratos,
    ano,
    mes,
  }: IConsultaRelatorioSAP): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url = APIService.API_URL + `informevendas`;

      me.http.post(
        url, 
        {
          contrato: contratos ? contratos.join(',') : '',
        },
        {
          headers: me.header,
          params: {
            empresa,
            ano: ano,
            mes: mes,
            operacao: 'consultarRelatoriosSAP',
          },
        }
      ).subscribe((result: any) => {
        try {
          var jsonData = typeof(result) == 'object' ? result : JSON.parse(result);

          if (jsonData) {

            var datasuccess = {
              Item: jsonData,
              erro: jsonData?.erro,
            };

            me.itemret = datasuccess;
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }

          resolve(me.itemret);
        } catch (error) {
          reject({
            Item: null,
            erro: error,
          });
        }
      }, (error) => {
        var msg = '';
        
        if (error.status == 401) {
          msg = error.statusText;
        } else {
          if (error.error) {
            msg = error.error;
          } else {
            msg = error.message;
          }
        }

        let errojson = msg;

        var errochamada = {
          Item: null,
          erro: errojson,
        };

        me.itemret = errochamada;
        reject(me.itemret);
      });
    });
  }
  
  getContatoContrato({empresa, contrato}: {empresa: string, contrato: string}): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas`;

      me.http.post(url, {}, {
         headers: me.header,
         params: {
          operacao: "contatoContrato",
          empresa,
          contrato
         }
       }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  getQtdAvisos({empresa, contrato, datade}: {empresa: string, contrato: string, datade: string}): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas`;

      me.http.post(url, {},{
         headers: me.header,
         params: {
          operacao: "qtdAvisos",
          empresa,
          contrato,
          datade
         }
       }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  /**
   * Lista informes pendentes
   */
  consultarVendasNaoInformadas({empresa, contratos}: {empresa: string, contratos: Array<string>}): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      //let url = APIService.API_URL + `informevendas?operacao=contratoAtividade&empresa=${empresa}&contrato=${contrato}&dataDe=2023-03-01T00:00:00&dataAte=2023-03-31T00:00:00`;
      let url =
        APIService.API_URL +
        `informevendas`;

      me.http.post(url, {
        contrato: contratos
        }, {
         headers: me.header,
         params: {
          operacao: "pendentesLancadosRelatorios",
          empresa,
         }
       }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData) {
            var datasuccess = {
              Item: jsonData,
              erro: '',
            };

            me.itemret = datasuccess;

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            if (error.error) {
              msg = error.error;
            } else {
              msg = error.message;
            }
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }
  
  /**
   * Atualiza usuário
   * @param dadosJson json com os dados da empresa&periodo
   * @returns
   */
  atualizarPeriodo(dadosJson: Array<any>): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      var requestData = JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'informevendas?operacao=abrirPeriodo';
      me.http.post(url, requestData, { headers: me.header }).subscribe(
        (result: any) => {
          var jsonData = result;

          if (jsonData.length != 0) {
            if (jsonData.status_ret != 'NOK') {
              var datasuccess = {
                Item: jsonData,
                erro: '',
              };
              me.itemret = datasuccess;
            } else {
              var errodatavazio = {
                Item: null,
                erro: 'Erro na atualização da empresa.',
              };
              me.itemret = errodatavazio;
            }

            resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Não há consultas.',
            };
            me.itemret = errodatavazio1;
          }
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            msg = error.error;
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  getAvisosInformeContrato(empresa: string, contrato: string): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'informevendas';

      me.http.post(url, {}, {
        headers: me.header,
        params: {
          operacao: 'avisosInformeContrato',
          empresa,
          contrato
        }
      }).subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }
  
  getAvisosBoletoUsuario(empresa: string, contrato: string): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'informevendas';

      me.http.post(url, {}, {
        headers: me.header,
        params: {
          operacao: 'avisosBoletoUsuario',
          empresa,
          contrato
        }
      }).subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  getAvisosInformeUsuario(empresa: string, contrato: string): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'informevendas';

      me.http.post(url, {}, {
        headers: me.header,
        params: {
          operacao: 'avisosInformeUsuario',
          empresa,
          contrato
        }
      }).subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns
   */
  addupdate(dadosJson: any) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      var requestData = JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'informevendas';
      
      if (dadosJson.Justificativa) {
        url += '?justificativa=' + dadosJson.Justificativa;
      }

      //console.log(requestData);
      me.http.post(url, requestData, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData.length != 0) {
            if (jsonData.status_ret != 'NOK') {
              var datasuccess = {
                Item: jsonData,
                erro: '',
              };
              me.itemret = datasuccess;
            } else {
              //console.log(jsonData.erro);
              var errodatavazio = {
                Item: null,
                erro: 'Erro na atualização da empresa.',
              };
              me.itemret = errodatavazio;
            }

            resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Não há consultas.',
            };
            me.itemret = errodatavazio1;
          }
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            msg = error.error;
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns
   */
  addUpdateLote(dadosJson: any[]): Promise<{Item: any, erro: any}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      var requestData = JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'informevendas?operacao=enviolote';
      
      // if (dadosJson.Justificativa) {
      //   url += '?justificativa=' + dadosJson.Justificativa;
      // }

      //console.log(requestData);
      me.http.post(url, requestData, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData.length != 0) {
            if (jsonData.status_ret != 'NOK') {
              var datasuccess = {
                Item: jsonData,
                erro: '',
              };
              me.itemret = datasuccess;
            } else {
              //console.log(jsonData.erro);
              var errodatavazio = {
                Item: null,
                erro: 'Erro na atualização da empresa.',
              };
              me.itemret = errodatavazio;
            }

            resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Não há consultas.',
            };
            me.itemret = errodatavazio1;
          }
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            msg = error.error;
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  delete(id: any) {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'empresa?id=' + id;

      me.http.delete(url, { headers: me.header }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData.length != 0) {
            if (jsonData.status_ret != 'NOK') {
              var datasuccess = {
                Item: jsonData,
                erro: '',
              };
              me.itemret = datasuccess;
            } else {
              var errodatavazio = {
                Item: null,
                erro: 'Erro na exclusão da empresa.',
              };
              me.itemret = errodatavazio;
            }

            resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            msg = error.error;
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }
}
